<template>
    <div class="flex flex-col gap-7">
        <timeline
            :is-group-posts-page="true"
            :group-ids="groupIds"
            :order="[ETimelineOrder.IS_PINNED, ETimelineOrder.PUBLISHED_AT_DESC]"
        />
    </div>
</template>

<script setup lang="ts">
    import Timeline from '~/components/timeline/TheTimeline.vue';
    import { useNavigationStore } from '~/stores/navigationStore';
    import { type PropType, onMounted, ref, type Ref } from 'vue';
    import { storeToRefs } from 'pinia';
    import { ETimelineOrder } from '~/types/enums';

    const props = defineProps({
        postGroupIds: {
            type: Array as PropType<number[] | null>,
            required: false,
            default: () => [],
        },
        archive: {
            type: Boolean as PropType<boolean>,
            default: false,
        },
    });

    const groupIds: Ref<number[] | null> = ref([]);
    const navigationStore = useNavigationStore();
    const { setShowArchive } = navigationStore;
    const { getLastActiveNavItem, currentNavigationLevel } = storeToRefs(navigationStore);

    onMounted( () => {
        if (!props.postGroupIds?.length && !currentNavigationLevel.value) {
            return showError({ statusCode: 404, name: 'No posts' });
        }

        if (props.postGroupIds?.length) {
            groupIds.value = props.postGroupIds;
            return;
        }

        setShowArchive(props.archive);

        const lastActiveItem = getLastActiveNavItem.value;
        if (lastActiveItem) {
            groupIds.value = lastActiveItem.postGroupIds;
            return;
        }
    });
</script>
